import React, {Component} from 'react';
import {connect} from 'react-redux'
import cn from 'classnames'
import flow from 'lodash/flow'

import withStyles from 'material-ui/styles/withStyles'
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import MenuIcon from 'material-ui-icons/Menu';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import Menu from 'material-ui/Menu'

import logo from '../img/logo.svg'

import {login, logout, toggleDrawer} from '../actions'
import {
    getAccountProfile,
    getAuthenticated,
    getProfileLoaded,
    getProfileName,
    getRoles,
    getShowMenu,
    getTitle
} from '../selectors'
import Avatar from 'material-ui/Avatar';
import first from 'lodash/first'
import throttle from 'lodash/throttle'
import {push} from 'react-router-redux'

class Header extends Component {

    state = {
        anchorEl: null,
        elevation: 4
    };

    componentWillMount() {
        //const {enableScrollShadow} = this.props;
        //if(enableScrollShadow) {
            this.updateElevation();
            this.throttled_updateElevation = throttle(this.updateElevation, 300);
            window.addEventListener("scroll", this.throttled_updateElevation);
        //}
    }

    componentWillUnmount() {
        if(this.throttled_updateElevation)
            window.removeEventListener("scroll", this.throttled_updateElevation);
    }

    updateElevation = () => {
        this.setState({
            elevation: window.scrollY === 0 ? 0 : 4
        })
    };

    handleAccountMenu = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleAccountMenuRequestClose = () => {
        this.setState({ anchorEl: null });
    };

    handleProfileClick = () => {
        this.setState({ anchorEl: null });
        this.props.handleProfile();
    };

    onLogout = () => {
        this.setState({ anchorEl: null });
        this.props.handleLogout();
    };

    onLogin = () => {
        this.props.handleLogin();
    };

    onDrawerToggle = () => {
        const {handleDrawerToggle} = this.props;
        handleDrawerToggle();
    };

    render() {
        const {classes, authenticated, accountProfile, roles, showMenu, title, profileName} = this.props;
        const { anchorEl, elevation } = this.state;
        const open = Boolean(anchorEl);

        var usersName = ! authenticated  ? 'Anonymous' : profileName ? profileName : accountProfile.name;

        return (<AppBar className={cn( classes.appBar, {[classes.appBarWithMenu]: showMenu})} color="default" position='fixed' elevation={elevation && 4} >
                <Toolbar>
                    <IconButton
                        color="not-contrast"
                        aria-label="open drawer"
                        onClick={this.onDrawerToggle}
                        className={classes.navIconHide}
                    >
                        <MenuIcon />
                    </IconButton>
                    <img src={logo} className={cn(classes.logo, {show: !showMenu})} alt="Evoenergy Logo"/>
                    <Typography type="title" noWrap className={classes.title}>{title}</Typography>
                    {!authenticated && <Button onClick={this.onLogin}>Login</Button>}
                    {authenticated &&
                    <div>
                        <IconButton
                            aria-owns={open ? 'menu-appbar' : null}
                            aria-haspopup="true"
                            onClick={this.handleAccountMenu}
                        >
                            <Avatar alt={usersName} src={accountProfile.picture}>{!accountProfile.picture && first(usersName)}</Avatar>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={open}
                            onRequestClose={this.handleAccountMenuRequestClose}
                        >
                            <div className={classes.accountMenuContainer}>
                                <div>
                                    <Avatar alt={usersName} src={accountProfile.picture} className={classes.accountMenuAvatar}>{!accountProfile.picture && first(usersName)}</Avatar>
                                </div>
                                <div className={classes.accountMenuDetails}>
                                    <Typography type="body2" >{usersName}</Typography>
                                    <Typography type="caption" gutterBottom >{roles}</Typography>
                                    <Typography type="caption" gutterBottom >{accountProfile.email}</Typography>
                                    <Button dense raised color="primary" onClick={this.onLogout} className={classes.accountMenuButton}>Logout</Button>
                                </div>
                            </div>
                        </Menu>
                    </div>

                    }
                </Toolbar>
            </AppBar>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        authenticated: getAuthenticated(state),
        showMenu: getShowMenu(state) && getProfileLoaded(state),
        accountProfile: getAccountProfile(state),
        profileName: getProfileName(state),
        roles: getRoles(state),
        title: getTitle(state)
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleDrawerToggle: () => {
            dispatch( toggleDrawer() );
        },
        handleLogout: () => {
            dispatch( logout() );
        },
        handleLogin: () => {
            dispatch( login() );
        },
        handleProfile: () => {
            dispatch( push('/register') );
        }
    }
};

const styles = (theme) => {
    return {
    appBar: {
        transition: `box-shadow 0.3s ease, ${theme.menu.transition('width')}`,
        //marginLeft: drawerWidth,
        [theme.breakpoints.up('md')]: {
            //width: `calc(100% - ${drawerWidth}px)`,
        },
    },
    appBarWithMenu: {
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${theme.menu.width}px)`,
        }
    },
    navIconHide: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    logo: {
        display: 'block',
        width: 100,
        marginTop: 4,
        marginRight: theme.spacing.unit,
        [theme.breakpoints.up('sm')]: {
            width: 150,
            marginTop: 8,
        },
        [theme.breakpoints.up('md')]: {
            display: 'none',
            width: 180,
            marginTop: 8,
            marginRight: theme.spacing.unit * 3,
        },
        '&.show': {
            display: 'block'
        }
    },
    title: {
        color: theme.palette.primary['500'],
        fontSize: '1rem',
        flex: 1,
        [theme.breakpoints.up('sm')]:
        {
            fontSize: '1.5rem',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '2rem'
        },
        '& span': {
            fontWeight: 200
        }
    },
    accountMenuContainer: {
        display: 'flex',
        minWidth: 250,
        margin: theme.spacing.small,
        justifyContent: 'flex-start',
        alignItems: 'flex-start'
    },
    accountMenuAvatar: {
        width: 64,
        height: 64,
        [theme.breakpoints.up('sm')]: {
            width: 96,
            height: 96,
        },
        marginRight: theme.spacing.normal,
    },
    accountMenuDetails: {
        flex: 1,
        fontSize: '1rem',
        display: 'flex',
        flexDirection: 'column',
        '& div': {
            marginBottom: theme.spacing.unit,
            color: theme.palette.text.secondary,
            ...theme.typography.body1,
        },
        '& strong': {
            color: theme.palette.text.primary
        }
    },

    accountMenuButton: {
        display: 'block',
        marginBottom: theme.spacing.unit
    }
    }
};

export default flow([
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
])(Header);




// WEBPACK FOOTER //
// ./src/components/Header.js